import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['modal'];

  connect() {
    $(this.element).modal('show');
  }

  close() {
    $(this.element).on('hidden.bs.modal', () => {
      this.removeModal();
      $(this.element).off('hidden.bs.modal');
    });
    $(this.element).modal('hide');
  }

  removeModal() {
    document.getElementById('modal').src = null;
    this.element.innerHTML = '';
    this.element.remove();
  }

  beforeCache() {
    this.removeModal();

    // hide without fading
    document.body.classList.remove('modal-open');
    const backdrops = document.getElementsByClassName('modal-backdrop');
    for (let i = 0; i < backdrops.length; i += 1) {
      backdrops[i].remove();
    }
  }
}
